import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentsTable {
    &__tags {
      display: flex;
      align-items: center;
      gap: 8px;

      &__caption {
        text-wrap: nowrap;
      }
    }

    &--onlyExecutedField {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    &__buttons {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 12px;

      &__metadata {
        width: 100%;
        max-width: 400px;
      }
    }

    &__export-buttons {
      display: flex;
      gap: 15px;

      &--select {
        width: 150px;

        .BaseSelectField {
          margin-bottom: 0;
          &__label {
            font-size: rem(15px);
            line-height: rem(22px);
            font-weight: 500;
            text-align: center;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .Select__control {
          min-height: 100% !important;
        }
      }
    }
  }

  /* ^^^ div-table */
  .PaymentsTable {
    .ReactDataTable__wrapper {
      overflow-x: auto;
      .ReactDataTable__thead {
        .ReactDataTable__thead-row {
          min-width: calc(100% - 12px);
          justify-content: space-between;
          margin: 0 6px 0 6px;
          padding: 0 18px 0 18px;
          display: grid;
          gap: 8px;

          @include respond-to(lg) {
            padding: 0 12px 0 12px;
          }

          .ReactDataTable__thead-cell {
            width: auto !important;
            white-space: normal;
            font-size: 13px;
            line-height: 20px;
            padding: 0 2px 0 2px;

            span {
              display: inline;
              font-size: 13px;
              line-height: 20px;
            }
          }
        }
      }

      .ReactDataTable__tbody {
        min-width: 0 !important;
        display: block;
        overflow: visible;

        .ReactDataTable__tbody-row {
          min-width: calc(100% - 12px);
          display: grid;
          gap: 8px;
          height: 70px;
          margin: 0 6px 0 6px;
          padding: 0 18px 0 18px;
        }

        .ReactDataTable__tbody-cell {
          width: auto !important;
          white-space: normal;
          font-size: 13px;
          line-height: 20px;
          padding: 0 2px 0 2px;
          .RowLink {
            justify-content: flex-start !important;
          }

          .status {
            span {
              display: block;
              line-height: 14px;
              white-space: wrap;
            }
          }

          .convertation-course {
            white-space: wrap;
          }

          span {
            display: inline;
            font-size: 13px;
            line-height: 20px;
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;
      span {
        text-align: center;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 5; /* email */
        }

        &:nth-child(2) {
          flex: 5; /* status */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__preview-main {
        height: 30px !important;
      }
      .ResponsiveTable__preview-description {
        display: flex;
        align-items: center;
        padding-right: 7%;
        .ResponsiveTable__row-item {
          &:nth-child(1) {
            flex: 5;
            .amount {
              color: black;
              font-weight: bold;
            }
          }

          &:nth-child(2) {
            flex: 5;
            font-size: 13px;

            .DateCell__time {
              display: none !important;
            }
          }
        }
      }

      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:nth-child(1) {
          flex: 5;
          font-size: rem(14px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        &:nth-child(2) {
          flex: 5;
          font-size: rem(12px);
          justify-content: center;
        }
      }

      .ResponsiveTable__details-item {
        margin-bottom: 3px !important;
      }
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .PaymentsTable {
      &__export-buttons--select,
      &__buttons__metadata {
        .BaseSelectField {
          .Select__control {
            border-color: ${colors.primary.hex} !important;
            &::after {
              border-color: ${colors.primary.hex};
            }
          }

          &__label {
            color: ${colors.primary.hex};
          }
        }
      }

      .ReactDataTable {
        .ReactDataTable__tbody {
          .ReactDataTable__tbody-row {
            .ReactDataTable__tbody-cell {
              &:nth-child(1) {
                a {
                  span {
                    color: ${colors.black.hex};
                  }
                }
              }

              &:nth-child(2) {
                span {
                  color: ${colors.secondary.hex};
                  &:after {
                    background: ${rgba([colors.secondary.rgb, 0.6])};
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
